import { render, staticRenderFns } from "./aloai-table.vue?vue&type=template&id=40d4c822&scoped=true"
import script from "./aloai-table.vue?vue&type=script&lang=js"
export * from "./aloai-table.vue?vue&type=script&lang=js"
import style0 from "./aloai-table.vue?vue&type=style&index=0&id=40d4c822&prod&scoped=true&lang=css"
import style1 from "./aloai-table.vue?vue&type=style&index=1&id=40d4c822&prod&lang=css"
import style2 from "./aloai-table.vue?vue&type=style&index=2&id=40d4c822&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d4c822",
  null
  
)

export default component.exports